import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const MessagePopup = ({ box, type, onClose, emailStatus }) => {
  if (!box) return null;

  const isNo = type === 'no';

  if (isNo) {
    return (
      <AnimatePresence>
        <motion.div
          className="popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="no-message-sheet"
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
            onClick={e => e.stopPropagation()}
          >
            <div className="popup-handle" />
            <div className="meme-wrapper">
              <img
                src="https://i.ibb.co/ccDMLM4p/Ft-Mmepya-AAILv-Qo.jpg"
                alt="Koochame illa"
                className="meme-img"
                onError={e => { e.target.style.display='none'; }}
              />
            </div>
            <div className="no-subtext">No click panra nee 😤</div>
            <button className="close-btn" onClick={onClose}>
              Okay okay
            </button>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    );
  }

  return (
    <AnimatePresence>
      <motion.div
        className="popup-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          className="message-sheet"
          initial={{ y: '100%' }}
          animate={{ y: 0 }}
          exit={{ y: '100%' }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          onClick={e => e.stopPropagation()}
        >
          <div className="popup-handle" />
          <div className="message-icon">{box.emoji}</div>
          <div className="message-label">Inspiration</div>
          <div className="message-title">{box.name}</div>

          {box.id === 'heart' ? (
            <div style={{ textAlign: 'center' }}>
              <div className="message-body" style={{ fontStyle: 'italic', fontSize: '18px', textAlign: 'center', borderLeft: 'none', borderTop: '4px solid #87CEEB' }}>
                Secrettt 🤫
              </div>
              <div style={{ marginTop: '14px' }}>
                {emailStatus === 'sending' && (
                  <div className="email-sending">
                    <div className="email-spinner" />
                    <div className="email-status">Sending your secret... 💌</div>
                  </div>
                )}
                {(emailStatus === 'sent' || emailStatus === 'error') && (
                  <div className="email-sending">
                    <div style={{ fontSize: '32px', marginBottom: '8px' }}>💌</div>
                    <div className="email-status" style={{ color: '#5BB8D4', fontWeight: '700' }}>
                      Something special is waiting... 🥹
                    </div>
                    <div className="mail-btn-row">
                      <button className="mail-btn later" onClick={onClose}>Later</button>
                      <button className="mail-btn now" onClick={onClose}>Now</button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="message-body">{box.inspiration}</div>
          )}

          {box.id === 'stomach' && (
            <div className="stomach-extra">
              Sooru Soooru Kolambu Kolambu Rasam Rasam apdi edhir paakaadha... idhu konjam Western-ised ah irukum :)
            </div>
          )}

          {(box.id !== 'heart' || emailStatus === 'sent' || emailStatus === 'error') && box.id !== 'heart' && (
            <button className="close-btn" onClick={onClose}>
              {box.closeMsg}
            </button>
          )}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default MessagePopup;
